import { isEqual } from 'lodash';
import { useDispatch } from 'react-redux';
import {
  createLegalEntityName,
  updateLegalEntityName,
} from '../store/actions/person/personActions';
import useApplicationUid from './useApplicationUid';

const useTrustNameDispatch = () => {
  const dispatch = useDispatch();
  const { ApplicationUid } = useApplicationUid();

  const trustNameDispatch = ({
    data,
    ApplicantData,
    defaultValues,
    onSuccess,
  }) => {
    const shouldSkip = isEqual(data, defaultValues) && data?.TrustName !== '';

    if (shouldSkip) {
      onSuccess();
      return;
    }

    const requestData = {
      ApplicationUid,
      data: {
        Name: data?.TrustName === '' ? null : data?.TrustName,
      },
      onSuccess,
    };
    if (ApplicantData && defaultValues) {
      dispatch(
        updateLegalEntityName({
          ...requestData,
        }),
      );
      return;
    }

    dispatch(
      createLegalEntityName({
        ...requestData,
      }),
    );
  };

  return { trustNameDispatch };
};

export default useTrustNameDispatch;
